import IsaprePlanModel from '@/models/HumanResource/HrIsaprePlan'

import axios from 'axios'
let route = process.env.VUE_APP_API_ROUTE + '/hr_isapre_plan'

const createIsaprePlan = async function(data) {
    try {
        let isaprePlan = new IsaprePlanModel(data)
        let response = await isaprePlan.save()
        return response
    } catch (error) {
        return error.response.data
    }
}

const deleteIsaprePlan = async function(id) {
    try {
        let response = await axios.delete(route + '/' + id)
        console.log('Elemento ' + id + ' eliminado')
        return response.data
    } catch (error) {
        return error.response.data
    }
}

const fetchIsaprePlan = async function(id) {
    try {
        let isaprePlan = await IsaprePlanModel.find(id)
        return isaprePlan
    } catch (error) {
        console.log('Error en fetch', error)
        return error.response.data
    }
}

const updateIsaprePlan = async function(id, data) {
    try {
        let isaprePlan = await fetchIsaprePlan(id)
        //-
        isaprePlan.hr_isapre_type_id = data.hr_isapre_type_id
        isaprePlan.uf_amount = data.uf_amount
        //-
        let response = await isaprePlan.save()
        //-
        return response
    } catch (error) {
        error.response.data
    }
}

export default {
    createIsaprePlan,
    deleteIsaprePlan,
    fetchIsaprePlan,
    updateIsaprePlan,
}
